<p-toast position="bottom-right"></p-toast>

<div class="card">
  <div class="card-footer ">
    <div class=""> <i class="fas fa-chart-line"> </i><strong> Status Logs (24H) </strong></div>
  </div>
  <div id="status-chart"></div>
  <div class="card-footer small-box-footer" style="text-align:center">
    <a *ngIf="isMonitored" href="#/line-status-history-full/{{lineId}}">
      More info <i class="fas fa-arrow-circle-right"></i>
    </a>
    <a *ngIf="!isMonitored" pTooltip="No more it's un-Monitoed">
      More info <i class="fas fa-arrow-circle-right"></i>
    </a>
  </div>
  <div class="overlay dark" *ngIf="loader" style="width: 100%; height: 280px">
    <i class="fas fa-2x fa-sync-alt fa-spin"></i>
  </div>
</div>







